module.exports = __webpack_public_path__ + "static/assets/4f12d87fa06425a1e578ef49bc63a6be.jpg";